<template>
  <div :class="['grc_checkbox_mobile_toggle', this.component_value==1 ? 'grc_checkbox_mobile_toggle_checked' : '']" @click="ToggleValue">
    <span :class="['grc_checkbox_mobile_togglespan', this.component_value==1 ? 'grc_checkbox_mobile_togglespan_checked' : '']"></span>
  </div>
</template>

<script>



export default {
  name: 'GrcCheckboxMobile',
  components:
  {

  },
  props: {
  },
  data () {
    return {
      component_value:0,
      readonly: false
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  methods: {

    SetReadonly(pReadonly)
    {
      this.readonly = pReadonly;
    },

    IsReadonly()
    {
      return (this.readonly);
    },

    SetValue(pValue)
    {
      this.component_value = pValue;
      this.$emit("valuechanged");
    },

    GetValue()
    {
      return this.component_value;
    },

    ToggleValue()
    {
        if (this.readonly) { return; }

        if (this.component_value==0) { this.SetValue(1); }
        else { this.SetValue(0); }

        
    }


    

    
  }
}
</script>

